import React, { useImperativeHandle, useRef, useState } from "react";
import useShowPDF from "@util/hook/useShowPDF";
import {
	AgreedNotesDialog,
	BatchPaymentMemoDialog,
	CalciumPushDialog,
	GuidanceNotesDialog,
	HundredTShirtSizeDialog,
	MeasureDayDialog,
	MemoDialog,
	NotificationDialog,
	MarketingDialog,
	ProbioticsPushDialog,
	ProteinPushDialog,
	SpecialConditionDialog,
	XFactorDialog,
	MemberHealthConditionDialog,
	TodoDialog,
	SpecialBodyConditionDialog,
} from "@icoach/memberDetail/dialog";
import InBodyAgreedNotesDialog from "@icoach/inbody/dialog/InBodyAgreedNotesDialog";
import InBodyXFactorDialog from "@icoach/inbody/dialog/InBodyXFactorDialog";
import InBodyStartScanDialogs from "@icoach/inbody/dialog/InBodyStartScanDialogs";
import InBodyHealthDeclarationReminderDialog from "@icoach/inbody/dialog/InBodyHealthDeclarationReminderDialog";
import InBodyDeleteMeasureDialog from "@icoach/inbody/dialog/InBodyDeleteMeasureDialog";
import InBodyInterviewNoteDialog from "@icoach/inbody/dialog/InBodyInterviewNoteDialog";
import { isEqual, isFunction } from "@util/utils";
import SmartRingPushDialog from "@icoach/memberDetail/dialog/SmartRingPushDialog";

const DELETE_MEASURE_DIALOG = "deleteMeasure";
const INTERVIEW_NOTES_DIALOG = "interviewNotes";
const MEMBER_SITE_QR_CODE_DIALOG = "memberSiteQrCode";
const X_FACTOR_DIALOG = "xFactorDialog";
const AGREED_NOTES_DIALOG = "agreedNotesDialog";
const MEASURE_DAY_DIALOG = "measureDayDialog";
const NOTIFICATION_DIALOG = "notificationDialog";
const MEMBER_DETAIL_DIALOG = "memberDetailDialog";
const GUIDANCE_NOTES_DIALOG = "guidanceNotesDialog";
const MEMO_DIALOG = "memoDialog";
const SPECIAL_CONDITION_DIALOG = "specialConditionDialog";
const MARKETING_DIALOG = "MarketingDialog";
const PROBIOTICS_PUSH_DIALOG = "probioticsPushDialog";
const PROTEIN_PUSH_DIALOG = "proteinPushDialog";
const CALCIUM_PUSH_DIALOG = "calciumPushDialog";
const SMART_RING_PUSH_DIALOG = "smartRingPushDialog";
const BATCH_PAYMENT_MEMO = "batchPaymentMemo";
const MEMBER_HEALTH_CONDITION_DIALOG = "memberHealthConditionDialog";
const TODO_DIALOG = "todoDialog";
const SPECIAL_BODY_CONDITION_DIALOG = "specialBodyConditionDialog";
const INBODY_AGREED_NOTES_DIALOG = "inBodyAgreedNotesDialog";
const INBODY_X_FACTOR_DIALOG = "inbodyXFactorDialog";
const INBODY_MEASUREMENT_TRIGGER_DIALOG = "inBodyMeasurementTriggerDialog";
const INBODY_HEALTHDECLARATION_REMINDER_DIALOG = "inBodyHealthDeclarationReminderDialog";

const InBodyInterviewDialogBox = React.forwardRef((props, ref) => {
	const showPDF = useShowPDF();
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState([]);
	const refreshRef = useRef(null);

	const handleDialogClose = () => {
		setOpenDialog(false);
		setSourceData([]);
	};

	const doRefresh = (...rest) => {
		isFunction(refreshRef.current) && setTimeout(() => refreshRef.current(...rest), 5);
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openDeleteMeasureDialog: (targetData, refreshFn) => {
					setSourceData(targetData);
					setOpenDialog(DELETE_MEASURE_DIALOG);
					refreshRef.current = refreshFn;
				},
				openInterviewNotesDialog: (targetData, refreshFn) => {
					setSourceData(targetData);
					setOpenDialog(INTERVIEW_NOTES_DIALOG);
					refreshRef.current = refreshFn;
				},
				openViewPdfDialog: (pdfUrl, onRefresh) => {
					showPDF({
						open: true,
						pdfUrl: pdfUrl,
						onRefresh: onRefresh,
					});
				},
				openMemberSiteQrCodeDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(MEMBER_SITE_QR_CODE_DIALOG);
				},
				openXFactorDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(X_FACTOR_DIALOG);
				},
				openAgreedNotesDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(AGREED_NOTES_DIALOG);
				},
				openMeasureDayDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(MEASURE_DAY_DIALOG);
				},
				openNotificationDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(NOTIFICATION_DIALOG);
				},
				openMarketingDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(MARKETING_DIALOG);
				},
				openHundredTShirtSizeDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(MEMBER_DETAIL_DIALOG);
				},
				openGuidanceNotesDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(GUIDANCE_NOTES_DIALOG);
				},
				openMemoDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(MEMO_DIALOG);
				},
				openSpecialConditionDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(SPECIAL_CONDITION_DIALOG);
				},
				openProbioticsPushDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(PROBIOTICS_PUSH_DIALOG);
				},
				openProteinPushDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(PROTEIN_PUSH_DIALOG);
				},
				openCalciumPushDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(CALCIUM_PUSH_DIALOG);
				},
				openSmartRingPushDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(SMART_RING_PUSH_DIALOG);
				},
				openBatchPaymentMemoDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(BATCH_PAYMENT_MEMO);
				},
				openMemberHealthConditionDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(MEMBER_HEALTH_CONDITION_DIALOG);
				},
				openTodoDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(TODO_DIALOG);
				},
				openSpecialBodyConditionDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(SPECIAL_BODY_CONDITION_DIALOG);
				},
				openInBodyAgreedNotesDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(INBODY_AGREED_NOTES_DIALOG);
				},
				openInBodyXFactorDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(INBODY_X_FACTOR_DIALOG);
				},

				openInBodyMeasurementTriggerDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(INBODY_MEASUREMENT_TRIGGER_DIALOG);
				},

				openInBodyHealthDeclarationReminderDialog: (targetDate, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetDate);
					setOpenDialog(INBODY_HEALTHDECLARATION_REMINDER_DIALOG);
				},

				closeDialog: () => handleDialogClose(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
			<InBodyDeleteMeasureDialog open={isEqual(openDialog, DELETE_MEASURE_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyInterviewNoteDialog open={isEqual(openDialog, INTERVIEW_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<XFactorDialog open={isEqual(openDialog, X_FACTOR_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<AgreedNotesDialog open={isEqual(openDialog, AGREED_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MeasureDayDialog open={isEqual(openDialog, MEASURE_DAY_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<NotificationDialog open={isEqual(openDialog, NOTIFICATION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MarketingDialog open={isEqual(openDialog, MARKETING_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
            <HundredTShirtSizeDialog open={isEqual(openDialog, MEMBER_DETAIL_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<GuidanceNotesDialog open={isEqual(openDialog, GUIDANCE_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MemoDialog open={isEqual(openDialog, MEMO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SpecialConditionDialog open={isEqual(openDialog, SPECIAL_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProbioticsPushDialog open={isEqual(openDialog, PROBIOTICS_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProteinPushDialog open={isEqual(openDialog, PROTEIN_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<CalciumPushDialog open={isEqual(openDialog, CALCIUM_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SmartRingPushDialog open={isEqual(openDialog, SMART_RING_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<BatchPaymentMemoDialog open={isEqual(openDialog, BATCH_PAYMENT_MEMO)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MemberHealthConditionDialog open={isEqual(openDialog, MEMBER_HEALTH_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<TodoDialog open={isEqual(openDialog, TODO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SpecialBodyConditionDialog open={isEqual(openDialog, SPECIAL_BODY_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyAgreedNotesDialog open={isEqual(openDialog, INBODY_AGREED_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyXFactorDialog open={isEqual(openDialog, INBODY_X_FACTOR_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyStartScanDialogs open={isEqual(openDialog, INBODY_MEASUREMENT_TRIGGER_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyHealthDeclarationReminderDialog open={isEqual(openDialog, INBODY_HEALTHDECLARATION_REMINDER_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default InBodyInterviewDialogBox;
